import React, { useState } from "react";
import CountProjectProvince from "./components/CountProjectProvince";
import DoughnutUnitFrameStruct from "./components/DoughnutUnitFrameStruct";
import DoughnutUnitFrameRebuild from "./components/DoughnutUnitFrameRebuild";
import BarCountWinDoor from "./components/BarCountWinDoor";
import BarCountStypeFitting from "./components/BarCountStypeFitting";
import { Box, Tab } from "@material-ui/core";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import SmallCountShow from "./components/SmallCountShow";
import BarChart from "./components/BarChart";
import SearchComponent from "./components/SearchComponent";

export default function TotalStatistics() {
  const { t } = useTranslation();
  const [value, setValue] = useState("project");
  const [dataSearch, setDataSearch] = useState(null);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <SmallCountShow />
      <Box className="mt-3">
        <TabContext value={value}>
          <Box>
            <TabList onChange={handleChange} variant="scrollable">
              <Tab
                label={t("statisticTotalProject")}
                value="project"
              />
              <Tab
                label={t("statisticTotalYaragh")}
                value="yaragh"
              />
              <Tab
                label={t("statisticDaily")}
                value="daily"
              />
            </TabList>
          </Box>
          <MuiPaper>
            <SearchComponent backSearchData={setDataSearch} />
          </MuiPaper>
          <TabPanel value="project" className="p-0 m-0 ">
            <CountProjectProvince height="300px" dataSearch={dataSearch} />
            <DoughnutUnitFrameStruct height="300px" dataSearch={dataSearch} />
            <DoughnutUnitFrameRebuild height="300px" dataSearch={dataSearch} />
          </TabPanel>
          <TabPanel value="yaragh" className="p-0 m-0 ">
            <BarCountStypeFitting height="300px" dataSearch={dataSearch} />
            <BarCountWinDoor height="300px" dataSearch={dataSearch} />
          </TabPanel>
          <TabPanel value="daily" className="p-0 m-0 ">
            <BarChart height="300px" dataSearch={dataSearch} />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
}
